// extracted by mini-css-extract-plugin
module.exports = {"formRender":"style__formRender__Sp5rl"};